import { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';

import { getConfig } from '@edx/frontend-platform';
import { fetchAuthenticatedUser, getAuthenticatedUser } from '@edx/frontend-platform/auth';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router';

import { setAuthenticatedUser } from './data/actions';
import {
  DEFAULT_REDIRECT_URL,
  REGISTER_PAGE,
} from '../data/constants';
import { getAllPossibleQueryParams } from '../data/utils';

/**
 * This wrapper redirects the requester to our default redirect url if they are
 * already authenticated.
 */
const UnAuthOnlyRoute = ({ children }) => {
  const [authUser, setAuthUser] = useState({});
  const [isReady, setIsReady] = useState(false);

  const location = useLocation();

  const queryParams = useMemo(() => getAllPossibleQueryParams(), [location.search]);

  const dispatch = useDispatch();

  useEffect(() => {
    fetchAuthenticatedUser({ forceRefresh: !!getAuthenticatedUser() }).then((authenticatedUser) => {
      dispatch(setAuthenticatedUser(authenticatedUser));
      setAuthUser(authenticatedUser);
      setIsReady(true);
    });
  }, [dispatch, location.pathname]);

  if (isReady) {
    if (
      location.pathname.includes(REGISTER_PAGE)
      && authUser
      && (queryParams.account_activation_status || queryParams.step === 'confirmation')
    ) {
      return children;
    }

    if (authUser && authUser.username) {
      global.location.href = getConfig().LMS_BASE_URL.concat(DEFAULT_REDIRECT_URL);
      return null;
    }

    return children;
  }

  return null;
};

UnAuthOnlyRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default UnAuthOnlyRoute;
